import React from "react";
import PropTypes from "prop-types";

import styles from "./new.module.css";
import { getRegExp, getSentenceFromCamelCase } from "./Helpers";

const Radio = ({
  checked,
  disabled,
  error,
  fixLength,
  required,
  label,
  minLength,
  maxLength,
  name,
  onChange,
  data,
  reqType,
  validationHandler,
  value,
  size = "medium",
  labelClassName,
  filter,
}) => {
  const onChangeHandler = (event) => {
    const { name, value, type, checked } = event.target;
    const inputValue = type === "checkbox" ? Boolean(checked) : value;

    onChange && onChange(name, inputValue);
  };

  const onValidationChange = (event) => {
    if (!validationHandler) return;

    const { value } = event.target;
    let errorMessage = "";

    if (!value && required) {
      errorMessage = `Please enter ${getSentenceFromCamelCase(name)}.`;
    } else if (minLength && value.length < minLength) {
      errorMessage = `${
        name.charAt(0).toUpperCase() + getSentenceFromCamelCase(name).slice(1)
      } must be at least ${minLength} characters long.`;
    } else if (maxLength && value.length > maxLength) {
      errorMessage = `${
        name.charAt(0).toUpperCase() + getSentenceFromCamelCase(name).slice(1)
      } must be ${maxLength} characters long.`;
    } else if (fixLength && value.length !== fixLength) {
      errorMessage = `${
        name.charAt(0).toUpperCase() + getSentenceFromCamelCase(name).slice(1)
      } must be ${fixLength} characters.`;
    } else if (value && reqType && !getRegExp(reqType).test(value)) {
      errorMessage = `Please enter valid ${getSentenceFromCamelCase(name)}.`;
    }

    validationHandler(name, errorMessage);
  };

  return (
    <div
      className={`${styles.radioFlex} ${styles[size || ""]} ${
        error ? styles.hasError : ""
      }`}
    >
      <label htmlFor={name} className={labelClassName || styles.inputLabel}>
        {label} {required && <span className={styles.required}>&nbsp;*</span>}
      </label>

      <div className={styles.modernRadioGroup}>
        {data.map((item, i) => {
          const optionValue = filter ? item[filter] : item.value;
          const optionLabel = filter ? item[filter] : item.label || item.value;
          const id = `${name}-${i}`;

          return (
            <label
              key={id}
              htmlFor={id}
              className={`${styles.modernRadioOption} ${
                value === optionValue ? styles.radioOptionActive : ""
              }`}
            >
              <input
                id={id}
                type="radio"
                onChange={onChangeHandler}
                value={optionValue}
                name={name}
                checked={value === optionValue || checked === optionValue}
                required={required}
                onBlur={onValidationChange}
                disabled={disabled}
              />

              <span className={styles.radioControl} />
              <span className={styles.radioText}>{optionLabel}</span>
            </label>
          );
        })}
      </div>

      {error ? (
        <span className={`${styles.required} ${styles.textSmall}`}>
          {error}
        </span>
      ) : null}
    </div>
  );
};

Radio.propTypes = {
  filter: PropTypes.string,
  checked: PropTypes.any,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  fixLength: PropTypes.number,
  required: PropTypes.bool,
  label: PropTypes.string.isRequired,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  reqType: PropTypes.string,
  validationHandler: PropTypes.func,
  value: PropTypes.any,
  size: PropTypes.string,
  labelClassName: PropTypes.string,
  data: PropTypes.array,
};

Radio.defaultProps = {
  filter: "",
  checked: false,
  disabled: false,
  error: "",
  fixLength: 0,
  required: false,
  minLength: 0,
  maxLength: 0,
  reqType: "",
  validationHandler: () => {},
  value: "",
  size: "medium",
  labelClassName: "",
  data: [],
};

export default Radio;
